<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/airManagement/warehousing";
export default {
  name: "",
  components: {
    cTable,
  },
  methods: {
    computedVolumn(row) {
      row.volume =
        parseFloat(
          (
            (row.height * row.width * row.length * row.quantity) /
            1000000
          ).toFixed(2)
        ) || 0;
    },
    handleTab(tab) {
      this.tabName = tab;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    },
  },
  data() {
    return {
      methods: {
        ...apis,
        list: async (params) => {
          if (!this.tabList.length) {
            await this.$refs.table.handleRequestMethods("type").then((res) => {
              this.tabList = res.payload;
              this.tabName = res.payload[0].value;
            });
          }
          params.type = this.tabName;
          return apis.list(params);
        },
      },
      tabList: [],
      tabName: "",
      config: {},
      footer: {},
      modals: {
        inbound: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ info: this.list });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz(""),
            modalBind: {
              width: 1200,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ number: 24 }],
          fields: [
            {
              name: () => this.$tz("入仓号"),
              key: "number",
              component: "Input",
              placeholder: () => this.$tz("入仓号"),
            },
          ],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: this.$t("case_number"),
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                },
                default: 0,
                placeholder: () => this.$t("enter") + this.$t("case_number"),
                minWidth: 110,
                key: "quantity",
                methods: {
                  "on-change": ({ row }) => {
                    this.computedVolumn(row);
                  },
                },
              },
              {
                name: this.$t("Weight"),
                key: "weight",
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                },
                default: 0,
                placeholder: () => this.$t("enter") + this.$t("Weight"),
                minWidth: 110,
                methods: {
                  "on-change": ({ row }) => {
                    this.computedVolumn(row);
                  },
                },
              },
              {
                name: this.$t("length"),
                key: "length",
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                },
                default: 0,
                placeholder: () => this.$t("enter") + this.$t("length"),
                minWidth: 110,
                methods: {
                  "on-change": ({ row }) => {
                    this.computedVolumn(row);
                  },
                },
              },
              {
                name: this.$t("width"),
                key: "width",
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                },
                default: 0,
                placeholder: () => this.$t("enter") + this.$t("width"),
                minWidth: 110,
                methods: {
                  "on-change": ({ row }) => {
                    this.computedVolumn(row);
                  },
                },
              },
              {
                name: this.$t("height"),
                key: "height",
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                },
                default: 0,
                placeholder: () => this.$t("enter") + this.$t("height"),
                minWidth: 110,
                methods: {
                  "on-change": ({ row }) => {
                    this.computedVolumn(row);
                  },
                },
              },
              {
                name: this.$t("skuVolume"),
                key: "volume",
                component: "InputNumber",
                bind: {
                  style: "width:100%",
                },
                default: 0,
                disabled: true,
                placeholder: () => this.$t("enter") + this.$t("skuVolume"),
                minWidth: 110,
              },
              {
                name: this.$t("Remarks"),
                key: "remarks",
                component: "Input",
                minWidth: 110,
                placeholder: () => this.$t("enter") + this.$t("Remarks"),
              },
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                show: () => {
                  return !this.read;
                },
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    icon: "md-add",
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                  },
                ],
                methods: {
                  add({ row, rowIndex }) {
                    this.getModal("inbound").list.splice(rowIndex + 1, 0, {
                      name: "",
                      length: 0,
                      height: 0,
                      width: 0,
                      quantity: 0,
                      volume: 0,
                      weight: 0,
                    });
                  },
                  delete({ row, rowIndex }) {
                    this.getModal("inbound").list.splice(rowIndex, 1);
                    if (!this.getModal("inbound").list.length)
                      this.getModal("inbound").list.push({
                        name: "",
                        length: 0,
                        height: 0,
                        width: 0,
                        quantity: 0,
                        volume: 0,
                        weight: 0,
                      });
                  },
                },
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "warehouse_id",
            placeholder() {
              return this.$tz("仓库");
            },
            component: "Select",
            options: [],
            optionsFn: "getWarehouse",
            optionsKey: "",
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: "",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("入库"),
              type: "inbound",
              fnName: "inbound",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            inbound() {
              this.getModal("inbound").open(null, function () {
                this.list.push({
                  name: "",
                  length: 0,
                  height: 0,
                  width: 0,
                  quantity: 0,
                  volume: 0,
                  weight: 0,
                });
                this.setTitle(this.$tz("入库"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("tracking order"),
          key: "number",
          minWidth: 130,
        },
        {
          name: () => this.$t("warehouse_t"),
          key: "warehouse",
          minWidth: 130,
        },
        {
          name: () => this.$t("Customer"),
          key: "customer",
          minWidth: 130,
        },
        {
          name: () => this.$tz("入仓,总数量"),
          key: "quantity",
          minWidth: 130,
        },
        {
          name: () => this.$tz("入仓,总重量"),
          key: "weight",
          minWidth: 130,
        },
        {
          name: () => this.$tz("入仓,总体积"),
          key: "volume",
          minWidth: 130,
        },
        {
          name: () => this.$tz("在仓,数量"),
          key: "residue_quantity",
          minWidth: 130,
        },
        {
          name: () => this.$tz("在仓,重量"),
          key: "residue_weight",
          minWidth: 130,
        },
        {
          name: () => this.$tz("在仓,体积"),
          key: "residue_volume",
          minWidth: 130,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>